export class PendingReviewDocumentCountDto {
  userId: string;
  count: number;
}
